import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    font-family: ${({ theme }) => theme.typography.fontFamily.secondary};
    font-size: ${({ theme }) => theme.typography.body.medium.fontSize};
    line-height: ${({ theme }) => theme.typography.body.medium.lineHeight};
    color: ${({ theme }) => theme.colors.text.primary};
    background-color: ${({ theme }) => theme.colors.background.default};
    transition: background-color ${({ theme }) => theme.transitions.duration.base} ${({ theme }) => theme.transitions.easing.inOut},
                color ${({ theme }) => theme.transitions.duration.base} ${({ theme }) => theme.transitions.easing.inOut};
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${({ theme }) => theme.typography.fontFamily.primary};
    color: ${({ theme }) => theme.colors.text.primary};
    margin: 0;
  }

  h1 {
    font-size: ${({ theme }) => theme.typography.heading.h1.fontSize};
    font-weight: ${({ theme }) => theme.typography.heading.h1.fontWeight};
    line-height: ${({ theme }) => theme.typography.heading.h1.lineHeight};
    letter-spacing: ${({ theme }) => theme.typography.heading.h1.letterSpacing};
  }

  h2 {
    font-size: ${({ theme }) => theme.typography.heading.h2.fontSize};
    font-weight: ${({ theme }) => theme.typography.heading.h2.fontWeight};
    line-height: ${({ theme }) => theme.typography.heading.h2.lineHeight};
    letter-spacing: ${({ theme }) => theme.typography.heading.h2.letterSpacing};
  }

  h3 {
    font-size: ${({ theme }) => theme.typography.heading.h3.fontSize};
    font-weight: ${({ theme }) => theme.typography.heading.h3.fontWeight};
    line-height: ${({ theme }) => theme.typography.heading.h3.lineHeight};
    letter-spacing: ${({ theme }) => theme.typography.heading.h3.letterSpacing};
  }

  h4 {
    font-size: ${({ theme }) => theme.typography.heading.h4.fontSize};
    font-weight: ${({ theme }) => theme.typography.heading.h4.fontWeight};
    line-height: ${({ theme }) => theme.typography.heading.h4.lineHeight};
    letter-spacing: ${({ theme }) => theme.typography.heading.h4.letterSpacing};
  }

  h5 {
    font-size: ${({ theme }) => theme.typography.heading.h5.fontSize};
    font-weight: ${({ theme }) => theme.typography.heading.h5.fontWeight};
    line-height: ${({ theme }) => theme.typography.heading.h5.lineHeight};
    letter-spacing: ${({ theme }) => theme.typography.heading.h5.letterSpacing};
  }

  h6 {
    font-size: ${({ theme }) => theme.typography.heading.h6.fontSize};
    font-weight: ${({ theme }) => theme.typography.heading.h6.fontWeight};
    line-height: ${({ theme }) => theme.typography.heading.h6.lineHeight};
    letter-spacing: ${({ theme }) => theme.typography.heading.h6.letterSpacing};
  }

  p {
    margin: 0;
    color: ${({ theme }) => theme.colors.text.primary};
  }

  a {
    color: ${({ theme }) => theme.colors.primary.main};
    text-decoration: none;
    transition: color ${({ theme }) => theme.transitions.duration.fast} ${({ theme }) => theme.transitions.easing.inOut};

    &:hover {
      color: ${({ theme }) => theme.colors.primary.dark};
    }
  }

  button {
    font-family: ${({ theme }) => theme.typography.fontFamily.secondary};
    cursor: pointer;
    border: none;
    outline: none;
    background: none;
  }

  input, textarea, select {
    font-family: ${({ theme }) => theme.typography.fontFamily.secondary};
    color: ${({ theme }) => theme.colors.text.primary};
    background-color: ${({ theme }) => theme.colors.background.paper};
    border: 1px solid ${({ theme }) =>
      theme.mode === 'dark' ? theme.colors.neutral[600] : theme.colors.divider};
    border-radius: ${({ theme }) => theme.borderRadius.md};
    padding: ${({ theme }) => theme.spacing[2]} ${({ theme }) => theme.spacing[3]};
    transition: all ${({ theme }) => theme.transitions.duration.fast} ${({ theme }) => theme.transitions.easing.inOut};
    -webkit-text-fill-color: ${({ theme }) => theme.colors.text.primary};
    // opacity: 1 !important;

    &::placeholder {
      color: ${({ theme }) => theme.colors.text.hint};
      -webkit-text-fill-color: ${({ theme }) => theme.colors.text.hint};
      opacity: 1;
    }

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-text-fill-color: ${({ theme }) => theme.colors.neutral[1000]};
      -webkit-box-shadow: 0 0 0 30px ${({ theme }) => theme.colors.neutral[0]} inset;
      box-shadow: 0 0 0 30px ${({ theme }) => theme.colors.neutral[0]} inset;
      transition: background-color 5000s ease-in-out 0s;
    }
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colors.background.default};
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.neutral[600]};
    border-radius: ${({ theme }) => theme.borderRadius.full};

    &:hover {
      background: ${({ theme }) => theme.colors.neutral[500]};
    }
  }

  ::selection {
    background: ${({ theme }) => theme.colors.primary.main}30;
    color: ${({ theme }) => theme.colors.text.primary};
  }

  .MuiPaper-root {
    background-color: ${({ theme }) => theme.colors.background.paper} !important;
    color: ${({ theme }) => theme.colors.text.primary} !important;
  }

  .MuiDrawer-paper {
    background-color: ${({ theme }) => theme.colors.background.paper};
  }

  .MuiAppBar-root.MuiPaper-root {
    background-color: ${({ theme }) => theme.colors.header.background} !important;
    color: ${({ theme }) => theme.colors.text.primary} !important;
  }

  .MuiButton-root {
    text-transform: none;
  }

  .MuiTypography-root {
    color: ${({ theme }) => theme.colors.text.primary};
  }

  @media (prefers-reduced-motion: reduce) {
    * {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
`;
